import React from 'react'

import type { GlobalErrorHandler, GlobalEventHandler } from '../../core'
import { GlobalStore } from '../../core/stores'

export interface GlobalStoreContextTypes {
  children: React.ReactNode
  onError: GlobalErrorHandler
  onEvent: GlobalEventHandler
  onLoad?: (widgetName: string) => void
  onPageView: (pageViewEvent: string) => void
  globalStore: GlobalStore
}
export const GlobalDataContext = React.createContext<GlobalStoreContextTypes | null>(null)

export const GlobalDataProvider: React.FC<React.PropsWithChildren<GlobalStoreContextTypes>> = ({
  children,
  globalStore,
  onError,
  onEvent,
  onLoad,
  onPageView,
}) => {
  return (
    <GlobalDataContext.Provider
      value={{
        globalStore,
        onError,
        onEvent,
        onLoad,
        onPageView,
        children,
      }}
    >
      {children}
    </GlobalDataContext.Provider>
  )
}
